/* eslint-disable max-statements */
import { ReactNode, useMemo } from 'react';

import { EnvironmentCountries } from '@e-origin/shared';

import { useSettings } from '@hooks/useSettings';
import { isHighValueDeclaration } from '../utils';

type Hide = 'DMS' | 'DECO' | 'IDMS_HV' | 'IDMS_EX' | 'IDMS_LV' | 'AES';

interface HideElementForProps {
  systems?: Hide[];
  declarationGroup?: string;
  children: ReactNode;
  condition?: () => boolean;
}

interface HideElementFunctionProps {
  systems?: Hide[];
  declarationGroup?: string;
  country: string;
  condition?: () => boolean;
}

export const hideElementFunction = ({ systems, declarationGroup, country, condition }: HideElementFunctionProps) => {
  if (condition && !!condition()) {
    return true;
  }

  if (country === EnvironmentCountries.NL) {
    if (isHighValueDeclaration(declarationGroup)) {
      return systems?.includes('DMS') || systems?.includes('AES');
    } else {
      return systems?.includes('DECO');
    }
  }

  if (country === EnvironmentCountries.BE) {
    if (isHighValueDeclaration(declarationGroup)) {
      return systems?.includes('IDMS_HV') || systems?.includes('IDMS_EX');
    } else {
      return systems?.includes('IDMS_LV');
    }
  }

  return false;
};

export const HideElementFor: React.FC<HideElementForProps> = ({ systems, declarationGroup, children, condition }) => {
  const { data: settings } = useSettings();

  const hideElement = useMemo(
    () => hideElementFunction({ systems, declarationGroup, country: settings.country, condition }),
    [systems, declarationGroup, settings.country, condition],
  );

  if (hideElement) return;

  return <>{children}</>;
};
